"use strict";

import React, { Component } from 'react';

import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';

import Footer from './footer';
import Header from './header';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
//import createPalette from '@material-ui/core/styles/createPalette';
import purple from '@material-ui/core/colors/purple';
import inscrito from './../modules/inscrito';
import red from '@material-ui/core/colors/red';
import Button from '@material-ui/core/Button';
var path = "/facopp/premiofacoppdefotografia/2018/";
// var green = {
//     50: '#e8f5e9',
//     100: '#c8e6c9',
//     200: '#a5d6a7',
//     300: '#81c784',
//     400: '#66bb6a',
//     500: '#508d83',
//     600: '#43a047',
//     700: '#508d83',
//     800: '#2e7d32',
//     900: '#1b5e20',
//     A100: '#b9f6ca',
//     A200: '#69f0ae',
//     A400: '#00e676',
//     A700: '#00c853',
//     contrastDefaultColor: 'dark'
// };

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#66bb6a',
            main: '#508d83',
            dark: '#508d83',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ff7961',
            main: '#f44336',
            dark: '#ba000d',
            contrastText: '#000',
        },
    },
});

class Master extends Component {
    state = {
        user: inscrito.getInscrito()


    }

    componentDidMount() {
        inscrito.onLogin((u) => this.setState({ user: u }));
    }



    sair(e) {
        e.preventDefault();
        sessionStorage.clear();
        window.location.href = "/facopp/premiofacoppdefotografia/2018/";//window.location.href;

    }

    render() {
        console.log("render: master");
        return (
            <MuiThemeProvider theme={theme}>
                <div className="">
                    <Header />
                    <main className="">
                        <nav className="menu">
                            <div className="limite">
                                <ul>
                                    <li><Link to={path}>  Início </Link></li>
                                    <li><Link to={path + "regulamento"} > Regulamento  </Link></li>
                                    <li className="btnEnviarFotos">
                                        <Link to={path + "inscrevase"}>  Inscreva-se  </Link></li>

                                    <li><Link to={path + "anteriores"}> Fotos de 2017  </Link></li>      
                                    <li><Link to={path + "certificado"}> Certificado de Participação  </Link></li>                                        
                                    <li><Link to={path + "contato"}> Contato  </Link></li>
                                    <li style={{
                                        display: this.state.user ? "inline-block" : "none"
                                    }}> <a href="javascript:;" onClick={this.sair} >Sair</a></li>
                                </ul>
                            </div>
                        </nav>
                        <div className="main-content">
                            {this.props.children}
                        </div>
                    </main>
                    <Footer />
                </div>
            </MuiThemeProvider>
        );
    }
};

export default Master;



// WEBPACK FOOTER //
// ./src/components/master.js